import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseError} from '../../../models/error/BaseError';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorPriority} from '../../../enums/ErrorPriority';
import {LowerCasePipe} from '@angular/common';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonGrid,
    IonIcon,
    IonItem,
    IonList,
    IonSelect,
    IonSelectOption
} from '@ionic/angular/standalone';
import {ErrorDetailRuleComponent} from '../error-detail-rule/error-detail-rule.component';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-error-detail-template',
    standalone: true,
    imports: [ScrollingModule, ReactiveFormsModule, RouterModule, FormsModule, LowerCasePipe, IonItem, IonSelect, IonButton, IonSelectOption, IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonGrid, IonList, IonItem, IonIcon, ErrorDetailRuleComponent, TranslatePipe],
    templateUrl: './error-detail-template.component.html',
    styleUrl: './error-detail-template.component.css'
})
export class ErrorDetailTemplateComponent {
    @Input({required: true}) error!: BaseError;
    @Input({required: true}) solveError!: () => Observable<void>;
    @Output() errorTypeUpdated = new EventEmitter<ErrorPriority>();

    public isSolvingError: boolean = false;
    public errorTypes: { value: string, translationKey: string }[] = [
        {value: "error", translationKey: "error.type.error"},
        {value: "warning", translationKey: "error.type.warning"},
        {value: "information", translationKey: "error.type.information"}
    ];

    public detailForm = new FormGroup({
        errorType: new FormControl<string>(this.errorTypes[0].value, {nonNullable: true})
    });

    public ngOnInit() {
        this.detailForm.patchValue({
            errorType: this.error.errorPriority
        });
    }

    public changeErrorType() {
        const values = this.detailForm.getRawValue();
        this.errorTypeUpdated.emit(values.errorType as ErrorPriority);
    }

    public onSolveErrorClick() {
        this.isSolvingError = true;
        this.solveError().subscribe({
            next: () => {
                this.error.isSolved = true;
                this.isSolvingError = false;
            },
            error: () => {
                this.isSolvingError = false;
            }
        })
    }
}
